var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMaterialuiOriginal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.200195 68.5999V13.3999L48.0002 40.9999V59.3999L16.1002 40.9999V77.7999L0.200195 68.5999Z",
    fill: "#1FA6CA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48 40.9999L95.9 13.3999V68.6999L64 86.9999L48 77.7999L80 59.3999V40.9999L48 59.3999V40.9999Z",
    fill: "#1C7FB6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48 77.7998V96.1998L80 114.6V96.1998L48 77.7998Z",
    fill: "#1FA6CA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80 114.6L127.8 86.9999V50.1999L111.8 59.3999V77.7999L80 96.1999V114.6ZM111.9 40.9999V22.5999L127.9 13.3999V31.7999L111.9 40.9999Z",
    fill: "#1C7FB6"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialuiOriginal);
export default __webpack_public_path__ + "static/media/materialui-original.5be606f350d01745920ae4cd973b6583.svg";
export { ForwardRef as ReactComponent };